import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { ThemeProvider } from 'styled-components';

import AppRouter from './MainRouter';

import lightTheme from '../theme/lightTheme';

import '../styles/shared.scss';

import 'primereact/resources/themes/lara-light-indigo/theme.css'; // primeng theme
import 'primereact/resources/primereact.min.css'; // core css
import 'primeicons/primeicons.css'; // icons
import Footer from '../components/Footer';

const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY;
const productsUrl = `${process.env.REACT_APP_BILLING_BASE_URL}selfserve/products`;
const saveOrderUrl = `${process.env.REACT_APP_BILLING_BASE_URL}selfserve/account/provision`;

function App() {
  const { pathname } = window.location;
  const showFooter = !pathname.includes('peacock-');
  const stripePromise = loadStripe(STRIPE_API_KEY, { locale: 'en' });

  let message;
  if (!STRIPE_API_KEY) {
    message =
      'Could not find stripe api key on env variables. Please ensure that REACT_APP_STRIPE_API_KEY its configured on .env file';
  }
  if (!productsUrl) {
    message =
      'Could not find products url on env variables. Please ensure that REACT_APP_BILLING_BASE_URL its configured on .env file';
  }
  if (!saveOrderUrl) {
    message =
      'Could not find stripe api key on env variables. Please ensure that REACT_APP_BILLING_BASE_URL its configured on .env file';
  }

  if (message) {
    console.error(message);
    return <h3 style={{ color: 'red' }}>{message}</h3>;
  }

  return (
    <Elements stripe={stripePromise}>
      <ThemeProvider theme={lightTheme}>
        <AppRouter />
        {showFooter && <Footer />}
      </ThemeProvider>
    </Elements>
  );
}

export default App;
